import React from 'react'

type Props = {
    className?              : string

    options                 : Option[]

    placeholder             : string
    allValuesOptionLabel    : string

    allValuesOption         : boolean

    onClick                 : func

    children                : any
}

// const debug = "SelectMultiGenericValueEmpty"
const debug = false

export default function SelectMultiGenericValueEmpty(props: Props) {
    let label = props.placeholder

    // check if all values option is enabled
    if (props.allValuesOption && !props.options) {
        label = props.allValuesOptionLabel
    }

    debug && console.log(debug, "render", label, props)

    const classes = Classes("ui5-field-form-editable dropdown-form h-36", props.className, {
        'ui5-txt-no-accent-default': !props.allValuesOption || !!props.options // for "Please select" label
    })

    return (
        <>
            <div className={classes} onClick={props.onClick}>
                {label}
            </div>
            {props.children}
        </>
    )
}